import templateStr from 'text!./mobileLobSummary.html';

function controller() {}

export default {
    template: templateStr,
    bindings: {
        offering: '<',
        branchCode: '<',
        lobCode: '&'
    },
    controller: controller
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/directives/LobOfferingSelection/mobileQuoteView/mobileLobSummary/mobileLobSummary.js
// module id = 2232
// module chunks = 0